import axios from '../plugins/axios';
import impressaoUtilitario from '../utilitarios/impressao.utilitario.js';

class impressaoService {
    async getBaseUrl() {
        return axios.get('urlImpressao');
    }
    
    async htmlToPdf(html, extraOptions) {
         let url = localStorage.getItem('url_impressao');
        if (url) {
            impressaoUtilitario.htmlToPDF(html, extraOptions, url);
        } else {
            let newUrl = await this.getBaseUrl().then((res) => res.data[0].url);
            localStorage.setItem('url_impressao', newUrl);
            impressaoUtilitario.htmlToPDF(html, extraOptions, newUrl);
        }
    }
}
export default new impressaoService();
//module.exports = new impressaoService();
